import React, { useState } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
} from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import menuConfig from "../../config/menuConfig";
import { filterMenu } from "../../config/filterMenu";


export default function Navbar() {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const [children, setChildren] = useState([]);

  const user = JSON.parse(sessionStorage.getItem("user"));

const roles =
  user?.role
    ?.split(";")
    .map((r) => r.trim())
    .filter(Boolean) || [];


  const [activeMenu, setActiveMenu] = useState(null);

  const handleOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(item.title);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActiveMenu(null);
  };



  const menus = filterMenu(menuConfig, roles);
  return (
    <Box
      sx={{
        display: { xs: "none", md: "flex" },
        gap: 1,
        bgcolor: "#1565c0",
        px: 2,
        py: 1,
      }}
    >
      {menus.map((item) =>
        item.children ? (
          <React.Fragment key={item.title}>
            <Button
              sx={{ color: "#fff" }}
              onClick={(e) => handleOpen(e, item)}
            >
              {item.title}
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && activeMenu === item.title}
              onClose={handleClose}
            >
              {item.children.map((sub) => (
                <MenuItem
                  key={sub.title}
                  onClick={() => {
                    navigate(sub.path, {
                      state: sub.state,
                    });
                    handleClose();
                  }}
                >
                  {sub.icon}
                  <Box sx={{ ml: 1 }}>{sub.title}</Box>
                </MenuItem>
              ))}
            </Menu>
          </React.Fragment>
        ) : (
          <Button
            key={item.title}
            component={NavLink}
            to={item.path}
            sx={{ color: "#fff" }}
          >
            {item.title}
          </Button>
        )
      )}
    </Box>
  );
}